import styled from "styled-components";
import { Colors } from "@core/utils/Colors";
import { Tooltip } from "@mui/material";
import { ColorButton } from "@shared/components/TiButton";

interface Props {
  label?: string;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  icon?: string;
  iconPosition?: 'left' | 'right';
  color?: ColorButton;
  tooltip?: string;
  type?: 'button' | 'submit' | 'reset';
}

const BorderlessButton = ({
  color = 'primary',
  label,
  disabled = false,
  onClick,
  className,
  icon,
  iconPosition = 'left',
  tooltip,
  type = 'button'
}: Props) => {
  return (
    <Tooltip title={tooltip}>
      <Button
        type={type}
        onClick={e => {
          e.stopPropagation();
          onClick && onClick();
        }}
        className={className + ' text-' + color}
        disabled={disabled}
      >
        {iconPosition == 'left' && <i className={icon}></i>}
        {label}
        {iconPosition == 'right' && <i className={icon}></i>}
      </Button>
    </Tooltip>
  );
};

export default BorderlessButton;

const Button = styled.button`
    padding: 4px 5px;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    outline: none;
    border: none;
    background: transparent;
    display: inline-block;
    transition: 150ms ease-in-out;
  
    &:hover {
        background: ${Colors.primary};
        color: white !important;
    }
`;
